export default theme => ({
  root: {
    overflow: "visible"
  },
  formControl: {
    width: "100%"
  }
});
